import React from "react";
import PageHeader from "@/components/layout/PageHeader";
import GlassCard from "@/components/ui-fleet/GlassCard";

export default function Settings() {
  return (
    <div data-testid="settings-page">
      <PageHeader title="Settings" breadcrumb="Account" />
      <GlassCard className="p-6">
        <h3 className="font-display text-[18px] mb-4" style={{ color: "var(--slate-900)" }}>Organization</h3>
        <div className="grid grid-cols-2 gap-4 mb-6">
          <Field label="Company" value="EQP India Pvt Ltd" />
          <Field label="Plan" value="Opsora Enterprise" />
          <Field label="Machines licensed" value="100" />
          <Field label="Region" value="India · Pan-India" />
        </div>
        <h3 className="font-display text-[18px] mb-4" style={{ color: "var(--slate-900)" }}>Preferences</h3>
        <div className="grid grid-cols-2 gap-4">
          <Field label="Currency" value="INR (₹)" />
          <Field label="Time zone" value="Asia/Kolkata" />
          <Field label="Language" value="English" />
          <Field label="SLA threshold" value="72 hours" />
        </div>
      </GlassCard>
    </div>
  );
}

function Field({ label, value }) {
  return (
    <div className="glass-card-sm p-3">
      <div className="text-[10px] uppercase tracking-wider mb-1" style={{ color: "var(--slate-500)" }}>{label}</div>
      <div className="text-[14px]" style={{ color: "var(--slate-900)" }}>{value}</div>
    </div>
  );
}
